const default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

// Switch for Chatgpt Content
const enableChatGptContent = false;

let resp_id;
let market;
let currency_code;

// Add default image url here
const tangent_default_selfie_image_url="https://file.tangent.ai/quiz-content/merchants/detoxmarket/image/16743381435446802-default%20image%20quizz.png";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const section_basics_container = document.getElementById("section_basics_sub_container");
const section_essentials_container = document.querySelector("#section_essentials_sub_container");
const section_add_on_container = document.querySelector("#section_add_on_sub_container");

const tangent_client_domain_url = window.location.origin;
const tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message"); 
const tangent_skin_type_tagging = document.querySelector("#skin-type-taging");

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

const isMobile = () => 
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches;

const sectionMapText = {
  cleanser:{
    am:`Begin your morning by gently cleansing your skin to remove any impurities or traces of overnight products.`,
    pm:`End your day by thoroughly cleansing your skin to remove makeup, sunscreen, and daily buildup, ensuring a fresh canvas for your nighttime routine.`
  },
  toner:{
    am:`Apply a hydrating toner to balance the skin's pH and prepare it for better absorption of the following products.`,
    pm:`Apply a hydrating and soothing toner to rebalance your skin after cleansing and prep it for better absorption of serums and moisturizers.`
  },
  serum:{
    am:`Use an antioxidant-rich serum to help combat free radicals and environmental stressors, which can contribute to the appearance of wrinkles.`,
    pm:`Apply a replenishing serum with ingredients like retinol, peptides, or hyaluronic acid to support overnight skin repair and renewal.`
  },
  moisturiser:{
    am:`Hydrate your skin with a moisturiser to keep it smooth and supple throughout the day.`,
    pm:`Lock in hydration with a rich night cream or moisturizer to keep your skin deeply nourished and restore its barrier while you sleep.`
  },
  "sun care":{
    am:`Apply SPF daily to protect against UV damage. Reapply every 2 hours, especially outdoors. Choose broad-spectrum, SPF 30+ for best defense. Hydrate and nourish skin.`,
    pm:``
  },
  exfoliator:{
    am:`Gently exfoliate in the morning to remove dead skin cells and refresh your complexion. Follow with hydration for a balanced glow.`,
    pm:`If needed, gently exfoliate to slough off dead skin cells and promote cell renewal, allowing your nighttime treatments to penetrate more effectively.`
  },
  "eye care":{
    am:`Use an eye cream to hydrate and brighten or an eye mask/patch to refresh and reduce puffiness.`,
    pm:`Apply an eye cream for hydration and repair or an eye mask/patch for deep overnight rejuvenation.`
  }
}

const skinTagMap = {
  normal_skin: "NORMAL",
  dry_skin: "DRY",
  oily_skin: "OILY",
  combination_skin: "COMBINATION",
  sensitive_skin: "SENSITIVE",
  concern_dryness: "DRYNESS",
  concern_dull: "DULLNESS",
  tangent_selfie_wrinkles: "FINE LINE/ WRINKLES",
  tangent_selfie_spots: "UNEVEN SKINTONE",
  tangent_selfie_acne: "ACNE",
  tangent_selfie_aging: "AGING",
  sensitivity: "SENSITIVITY",
  concern_dehydrated: "DEHYDRATED"
};

// Tab title mapping based on tags
const tabs_title_mapping={
  section_basics:"The Essentials",
  section_essentials:"The Full Routine"
}

// Message for each conditions
const condition_text_mapping = {
  dark_circles:"Prone to dark circles here! Try our <a target='_blank' href='/products/odacite-baobab-sarsaparilla-serum'><u>Ba + S | Eye Contour</u></a>.",
  wrinkles:"Prone to wrinkles here! Try our <a target='_blank' href='/products/odacite-rosehip-ylang-ylang-serum'><u>Ro + Y | Deep Wrinkles</u></a>",
  rosacea:"Prone to rosacea here! Try our <a target='_blank' href='/products/odacite-immortelle-refreshing-toner-mist'><u>Aloe + Immortelle Hydra-Repair Treatment Mist</u></a>",
  texture:"Prone to texture here! Try our <a target='_blank' href='/products/odacite-edelweiss-extreme-derm-restore-super-serum'><u>Edelweiss Extrême Derm-Restore Super Serum</u></a>",
  darkspots:"Prone to darkspots here! Try our <a target='_blank' href='/products/odacite-papaya-geranium-serum'><u>Pa + G | Hyperpigmentation</u></a>",
  acne:"Prone to acne here! Try our <a target='_blank' href='/products/odacite-black-cumin-cajeput-serum'><u>Bl + C | Pimples</u></a>"
}

let amRoutineStepCount =0;
let pmRoutineStepCount =0;

// Add Section names to be excluded in the respective routine
let am_routine_sections=["section_hidden_lips","section_hidden_supplement","section_hidden_tools"];
let pm_routine_sections=["section_hidden_lips","section_hidden_supplement","section_hidden_tools","section_sun_care"];

let tangent_product_sections;
let tangent_recommended_products;
let selected_variants_map;

// Product ID to single Variant ID mapping
let tangent_selected_product_map;
let tangent_selfie_id;

let chat_gpt_response;
let tangent_quiz_tags=[];

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

let variant_product_map={};

let tangent_client_domain_currency;

let isPageLoadCalled = false;

// Use DOMContentLoaded to catch early loading
document.addEventListener("DOMContentLoaded", onLoadFunction);

// Use window.onload to catch full page load (if needed)
window.addEventListener("load", onLoadFunction);

function onLoadFunction(){
  if (!isPageLoadCalled) {
    isPageLoadCalled = true;
    const tangent_response_id = getClientResponseId();
    if (tangent_response_id != null) {
      market = document.getElementById("tangent-shop-market").value;
      const tangent_chatgpt_api_url = "https://service.tangent.ai/shopify/llm-recommendation?resp_id="+tangent_response_id;
      const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true"+"&market="+market;

      enableChatGptContent ? doApiCall("chat_text",tangent_chatgpt_api_url) : setElementDisplayById('tangent-am-pm-section','flex');
      
      doApiCall("recommendation",checkout_url); 
    }
  }
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  resp_id = tangent_client_url.searchParams.get("resp_id");
  return resp_id;
}

function doApiCall(type, url){
    fetch(url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      if(type=="chat_text"){
        setChatGPTTextForSelfie(response);
      }
      else{
        checkoutDataProcess(response);
      }
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// FOR CHAT GPT CONTENT
const safeParseJsonAndClean = (jsonString) => {
    try {
        // Remove all \n (newlines) before parsing
        jsonString = jsonString.replace(/\n/g, ' ');
        jsonString = jsonString.replace("```json", '');
        jsonString = jsonString.replace("```", '');

        // Parse the JSON string into an object
        let parsedData = JSON.parse(jsonString);

        // Function to recursively clean newlines from object properties
        function cleanObject(obj) {
            if (typeof obj === "string") {
                return obj.replace(/\n/g, ' ').trim(); // Remove newlines and trim spaces
            } else if (Array.isArray(obj)) {
                return obj.map(cleanObject); // Recursively clean arrays
            } else if (typeof obj === "object" && obj !== null) {
                for (let key in obj) {
                    obj[key] = cleanObject(obj[key]); // Recursively clean object properties
                }
            }
            return obj;
        }

        return cleanObject(parsedData);
    } catch (error) {
        console.error("Invalid JSON string:", error.message);
        return null; // Return null if parsing fails
    }
}

function setChatGPTTextForSelfie(response_body){
  const chat_gpt_response = safeParseJsonAndClean(response_body.response.choices[0].message.content);
  
  var section_selfie = document.querySelector("#section_selfie_container_parent");
  section_selfie.innerHTML = `<div><div class="text-container-section">${chat_gpt_response.skin_assessment}</div></div>`;
  setElementDisplayById('tangent-am-pm-section','flex');
}

function checkoutDataProcess(response){
    tangent_recommended_products = response.products;
    selected_variants_map = response.selected_variants;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText+" "; 
    
    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);

    createTabButtons();

    tangent_quiz_tags = response.tags;

    setSelfieSkinTagging();
  
    tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
  
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    
  
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_product_sections, selected_variants_map);
      enableButtonListener();
      loadElementsOnResponseData(); 
      
      // Initial Tab setting
      setTabOpen(response.tags);
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
      setElementDisplayById('tangent-general-text','block');
    }

    setupTabs();
}

// TAGS TO SHOW UNDER SELFIE
const setSelfieSkinTagging = () => {
  const tag = tangent_quiz_tags
    .filter(tag => skinTagMap[tag])
    .map(tag => `<h2>${skinTagMap[tag]}</h2>`)
    .join(' <span class="tag-dot-icon">&#9679;</span> ');

  tangent_skin_type_tagging.innerHTML = tag;
};

// Utility function to scroll to a tab
const scrollToTab = (tabsContainer, tabButton) => {
    const position = tabButton.getBoundingClientRect();
    const scroll = tabsContainer.scrollLeft;
    tabsContainer.scrollTo({
        left: scroll + position.left - tabsContainer.offsetLeft - 30,
        behavior: 'smooth',
    });
};

// Utility function to hide all content divs
const hideAllTabContents = () => {
    document.querySelectorAll('.tabcontent').forEach(div => {
        div.style.display = 'none';
    });
};

// Utility function to show the corresponding content
const showTabContent = (tabButton) => {
    const targetDiv = document.querySelector(`#${tabButton.name}_container`);
    if (targetDiv) {
        targetDiv.style.display = 'block';
    }
};

const updateAddOnSectionButtonAndText = (tabActiveSection) => {
  let addOnDiscount = 10;
  if(tabActiveSection=="section_essentials"){
    addOnDiscount = 15;
  }
  setAddOnDiscountText(addOnDiscount);
  setAddOnAddAllToCartButton("section_add_on", tabActiveSection);
}

// Utility function to update active class
const updateActiveTab = (tabButtons, activeButton) => {
    tabButtons.forEach(button => button.classList.remove('active'));
    activeButton.classList.add('active');

    // Custom Modification For Add Discount Part
    updateAddOnSectionButtonAndText(activeButton.name);
};

// Main logic for setting up tabs behaviour
const setupTabs = () => {
    const tabsContainer = document.querySelector('.tab');
    const tabButtons = document.querySelectorAll('.tab button');

    tabButtons.forEach(tabButton => {
        tabButton.addEventListener('click', function () {
            // Scroll to the clicked tab
            scrollToTab(tabsContainer, this);

            // Hide all content divs and show the corresponding content
            hideAllTabContents();
            showTabContent(this);

            // Update active class for the tabs
            updateActiveTab(tabButtons, this);
        });
    });
};

// Selfie Mapping data api call
function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango" 
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              tangent_facemap_data = response_json["selfie_record"][0].facemap;
              setScores(tangent_facemap_data.scores);
              
              document.getElementById("tangent_section_selfie_parent_wrapper").classList.add('selfie-section-flow');
              document.querySelector("#canvas_img").setAttribute("src",tangent_facemap_data.url);

              setElementDisplayById('image-parent-container','flex');
              setElementDisplayById('hideHighlight','flex');
              setElementDisplayById('image-loading-section','none');
              setElementDisplayById('tangent_score_description','block');
              setElementDisplayById('chatgpt-text-loading-section','flex');
              
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

const getProductFromId = (id) =>{
  return tangent_recommended_products.find(p => String(p.id) === id);
}

const addToSectionGridContainer = (grid_continer, product_html) => {
  grid_continer.innerHTML = grid_continer.innerHTML + product_html;
}

const getGridsAvailableForSection = (section) => {
  const basic_grid = document.getElementById("basic_"+section+"_product_grid");
  const essential_grid = document.getElementById("essential_"+section+"_product_grid");
  const add_on_grid = document.getElementById("add_on_"+section+"_product_grid");
  const am_container = document.getElementById("section_am_container");
  const pm_container = document.getElementById("section_pm_container");

  return { basic_grid , essential_grid , add_on_grid , am_container , pm_container };
}
 
function setProductsToView(sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    if(section!="section_basics" && section!="section_essentials" && section!="section_add_on"){
      const { basic_grid , essential_grid , add_on_grid , am_container , pm_container } = getGridsAvailableForSection(section);
      
      // Create a document fragment for improved performance
      let basic_fragment = document.createElement('div');
      let essential_fragment = document.createElement('div');
      let add_on_fragment = document.createElement('div');
      let max_product_show_count= 1
        
      if(isDarkCircleDetected() && section=="section_eye_care"){
        max_product_show_count=2;
        adjustAddOnProductContainerStyle();
      }
      let product_shown_count = 0;
      
      product_ids.forEach(id => {
          const product = getProductFromId(id);
          
          if (product_shown_count >= max_product_show_count) return;
          
          const productIndex = tangent_recommended_products.indexOf(product);
          const product_html = getProductHTML(product, productIndex, section, selected_variants, "normal");
          
          if (product_html) {
              product_shown_count++;
              appendProductToGridContainer(basic_grid, essential_grid, add_on_grid, product_html, section, product);
              appendProductToRoutineGridContainer(am_container, pm_container, section, product, productIndex, selected_variants);
          }
      });
    }
    else{
      handleAddAllToCartForParentSections(product_ids,section, selected_variants);
    }
  });
}

// Routine Product View
const appendProductToRoutineGridContainer = (am_container, pm_container, sectionName, product, productIndex, selected_variants) => {
  [am_container, pm_container].forEach(grid => {
    if (!grid) return;

    if (isDarkCircleDetected() && sectionName === "section_exfoliator") {
      return;
    }

    const isAM = grid.id.includes("section_am");
    const routineSections = isAM ? am_routine_sections : pm_routine_sections;

    if (!routineSections.includes(sectionName)) {
        routineSections.push(sectionName);
        isAM ? amRoutineStepCount+=1 : pmRoutineStepCount+=1 ;
        const routineType = isAM ? "routine-am" : "routine-pm";
        const routine_product_card = getProductHTML(product, productIndex, sectionName, selected_variants, routineType);
        addToSectionGridContainer(grid, routine_product_card);
    }
  });
}

function handleAddAllToCartForParentSections(product_ids, section, selected_variants){
  product_ids.forEach(id => {
    const product = tangent_recommended_products.find(p => String(p.id) === String(id));
  
    if (!product) { return; }
  
    const variant = getVariantOfProductFromSelected(product, selected_variants);
  
    if (!variant) { return; }
    if (isProductAvailable(product, variant)) {
      updateSectionAllToCartLink(section, variant);
    }
  });
}

function changeCheckboxIds(parentSection, section, product) {
  let mainContainerId = `#${parentSection}_${section}_product_grid`;
  
  document.querySelectorAll(`${mainContainerId} .tangent-product-item`).forEach((item, index) => {
    let buttons = item.querySelectorAll(".more_info_button");

    let addCartbuttons = item.querySelectorAll(".mobile-add-button-container");
    let contentDivs = item.querySelectorAll(".toggle-content");

    
    let baseId = `${parentSection}_${section}`;

    buttons.forEach((button, btnIndex) => {
      let newId;
      if (button.id && button.id.includes(parentSection)) {
        newId = `${baseId}_${product.id}${btnIndex}`;
      } else {
        newId = `${baseId}_${product.id}`;
      }
      button.setAttribute("id", newId);

      // Apply unique class to contentDivs
      contentDivs.forEach(contentDiv => contentDiv.classList.add(newId));
      addCartbuttons.forEach(cartButton => cartButton.classList.add(newId+"_button"));
    });
  });
}

function getVariant(product, variant_id) {
  const variant_list = product.variants?.edges ?? []; // Handle cases where `edges` is missing

  return variant_list.find(variant => variant.node.id === variant_id)?.node || null;
}

const adjustAddOnProductContainerStyle = () => {
  const eyeCareContainer =  document.querySelector("#section_eye_care_container");
  eyeCareContainer.classList.add("tangent-double-product-eyecare");
}
  
function getProductHTML(product, index, section, selected_variants, type) {
  let variant = getVariantOfProductFromSelected(product, selected_variants);
  if(isProductAvailable(product, variant)){
    tangent_selected_product_map[product.id] = variant.id;

    // Destructuring for clarity
    const { contextualPricing: productPrice, id: variantId, title: variantTitle, image_id: variantImageId } = variant;
    const { handle: productHandle, title: productTitle } = product;
    
    // Set URLs and image
    const variantImageUrl = product.images.nodes[0].url;
    const variantProductUrl = `${product.onlineStoreUrl}?variant=${variantId}`;
  
    let variantLabel = "";
    // Determine if variant title is shown
    if(variantTitle!="Default Title"){
      variantLabel = `${variantTitle}`;
    }
    currency_code = getCurrencyCode(productPrice.price.amount, productPrice.price.currencyCode);
    const priceText = getCurrencyCode(productPrice.price.amount, productPrice.price.currencyCode) +" "+ productPrice.price.amount;//tangent_client_domain_currency+productPrice;
    
    // Product HTML using template literals
    return createProductCardHTML(product, section, index, variantProductUrl, variantImageUrl, variantId, productTitle, variantLabel, priceText, type);
  }
  else{
    console.log("product not available");
    return null;
    
  }
}

const getCurrencyCode = (amount, currencyCode) => {
  if ("us" == market || "au" == market) return "$";
  {
      let t = currencyCode;
      return new Intl.NumberFormat(Number(amount), {
          style: "currency",
          currency: t
      }).formatToParts("1").find(e => e.type = "currency").value
  }
}

// Filter for removing product with the given tag
const isProductSubcribeActive = (product) =>{
  return product.tags.includes("rebuyOOS");
}

const getComingSoonButtonHTML = (url) => {
  return `
    <p class="tangent-btn-add tangent-add-to-cart-button">
      <a href="${url}" target="_blank">
        Coming Soon...
      </a>
    </p>
  `;
}
  
const getAddToCartButtonHTML = (section, index, variantId) => {
  return `
    <p class="tangent-btn-add tangent-add-to-cart-button" id="${section}_cart_tangent_product_${index}_text">
      <a class="tangent-product-add-btn-wrapper" id="${variantId}" href="javascript:void(0)">
        ${default_addToCartText}
      </a>
    </p>
  `;
}

const getNormalProductCardHtml = (section, index, variantId, variantProductUrl, variantImageUrl, productTitle, product, priceText, productAddToCartHTML) => {
  return `
    <div class="tangent-product-item">
      <div>
        ${getSwitchButton(section, index, variantId)}
        ${getProductImageContainer(index, variantProductUrl, variantImageUrl, productTitle)}
        <div class="product-card-text-container">
          <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
            <p class="tangent-product-vendor-name">${product.vendor}</p>
            <p class="tangent-product-title tangent-product-title-text">
              <b>${productTitle}</b>
            </p>
            <p id="price_tangent_product_${index}" class="tangent-product-price-text">
              ${priceText}
            </p>
          </a>
          <div class="product-description-content">
            <div class="tangent-hide-mobile">
              <button type="button" 
                data-productId=${product.id} 
                data-functionType="open" 
                data-sectionName=${section} 
                class="more_info_button">+ More Info</button>
              <div class="toggle-content ${section}_${product.id}_toggle-content tangent-hide-element">
                  <p>${product.body_html}</p>
              </div>
              ${productAddToCartHTML}
            </div>
            <div class="tangent-hide-laptop">
              <button 
                data-productId=${product.id} 
                data-functionType="open" 
                data-sectionName=${section}
                class="more_info_button">+ More Info</button>
              <div id="mobile_toggle_${section}_${product.id}_button" class="mobile-add-button-container ">${productAddToCartHTML}</div>
            </div>

          </div>
        </div>
      </div>
      <div class="mobile-screen-description tangent-hide-laptop">
        <div class="toggle-content ${section}_${product.id}_toggle-content tangent-hide-element">
            <p>${product.body_html}</p>
            ${productAddToCartHTML}
        </div>
      </div>
    </div>
  `;
}

function createProductCardHTML(product, section, index, variantProductUrl, variantImageUrl, variantId, productTitle, variantLabel, priceText, type){
  
  let productAddToCartHTML = getAddToCartButtonHTML(section, index, variantId);
  
  if(isProductSubcribeActive(product)){
    productAddToCartHTML = getComingSoonButtonHTML(variantProductUrl);
  }
  else{
    updateVariantProductMap(product,variant);
    updateSectionAllToCartLink(section, variant);
  }
  let cardHTML = ``;
  if(type=="normal"){
    cardHTML = getNormalProductCardHtml(section, index, variantId, variantProductUrl, variantImageUrl, productTitle, product, priceText, productAddToCartHTML);
  }
  else{
    cardHTML = createRoutineProductCard(section, index, variantProductUrl, variantImageUrl, productTitle, productAddToCartHTML, type)
  }
  return cardHTML;
}

// Used for Variant To Product Mapping
// Used in Add All To Cart Event track
function updateVariantProductMap(product,variant){
  variant_product_map[variant.id] = product.id;
}

function getProductImageContainer(index, variantProductUrl, variantImageUrl, productTitle){
  return `
  <div class="tangent-product-image-container">
    <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
      <img id="image_tangent_product_${index}" src="${variantImageUrl}" class="tangent-product-image" alt="${productTitle}">
    </a>
  </div>
  `;
}

function getSwitchButton(section, index, variantId) {
  if (!isDarkCircleDetected() || section !== "section_eye_care") {
    return `
      <button class="tangent-switch-product-button" onclick="switchProduct('${index}','${section}','${variantId}')">
        <span style="font-size:21px">&#x27F3;</span> <u>More Options</u>
      </button>
    `;
  }
  return "";
}

const getRoutineCardTexts = (type, section) => {
  const sectionName = section.replace("section_", "").replace("_", " ");  
  let routineText = "";
  let routineCardTitle = "STEP ";
  if (type === "routine-am") {
    routineText = sectionMapText[sectionName]?.am || "";
    routineCardTitle+= amRoutineStepCount;
  } else {
    routineText = sectionMapText[sectionName]?.pm || "";
    routineCardTitle+= pmRoutineStepCount;
  }
   routineCardTitle+=": "+ sectionName;
  return { routineText , routineCardTitle };
}

function createRoutineProductCard(section, index, variantProductUrl, variantImageUrl, productTitle, productAddToCartHTML, type) {
  
  const { routineText , routineCardTitle } = getRoutineCardTexts(type, section);

  let cardHTML = `
    <div class="tangent-product-item">
      <div>
        <p class="section-name">${routineCardTitle}</p>
        <p class="routine-text">${routineText}</p>
      </div>
      <div>
        <div class="tangent-product-image-container">
          <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
            <img id="image_tangent_product_${index}" src="${variantImageUrl}" class="tangent-product-image" alt="${productTitle}">
          </a>
        </div>
        <div>
          ${productAddToCartHTML}
        </div>
      </div>
    </div>
  `;

  return cardHTML;
}

const getNewId = (ids, currentId) => {
    //const filteredIds = ids.filter(id => id !== currentId);
    //return filteredIds.length ? filteredIds[Math.floor(Math.random() * filteredIds.length)] : null;
    
    if (!ids.length) return null;
    
    const index = ids.indexOf(currentId);
    if (index === -1) return null;
    
    return ids[(index + 1) % ids.length];
}

const getVariantById = (product, variant_id) => 
  product.variants.edges.find(variant => variant.node.id === variant_id) || null;

// Normal Product View
const appendProductToGridContainer = (basic_grid, essential_grid, add_on_grid, product_html, sectionName, product) => {
  [basic_grid, essential_grid, add_on_grid].forEach(grid => {
    if(grid){
      let parentSection = grid.getAttribute("parentsection");
      addToSectionGridContainer(grid, product_html);
      changeCheckboxIds(parentSection,sectionName, product);
    }
  });
}

// More Options Button Function
function switchProduct(index, sectionName, variantId) {
  let previousProduct = tangent_recommended_products[index];
  
  // Fetch new Id from the sections
  let newProductId = getNewId(tangent_product_sections[sectionName], previousProduct.id);
  
  let attempts = 0;
  const maxAttempts = 3; // Adjust based on expected product pool size
  
  while (newProductId && attempts < maxAttempts) {
    attempts++;
    
    let newProduct = getProductFromId(newProductId);
    if (!newProduct) {
      newProductId = getNewId(tangent_product_sections[sectionName], previousProduct.id);
      continue;
    }

    let newVariant = getVariantOfProductFromSelected(newProduct, selected_variants_map);
    if (!newVariant || !isProductAvailable(newProduct, newVariant)) {
      newProductId = getNewId(tangent_product_sections[sectionName], previousProduct.id);
      continue;
    }

    // If a valid product is found, update the section
    const { basic_grid , essential_grid , add_on_grid , am_container , pm_container } = getGridsAvailableForSection(sectionName);
    
    // Clear existing grids
    [ basic_grid, essential_grid, add_on_grid ].forEach(grid => grid && (grid.innerHTML = ''));

    const productIndex = tangent_recommended_products.indexOf(newProduct);
    
    const product_html = getProductHTML(newProduct, productIndex, sectionName, selected_variants_map, "normal");
    
    if (product_html) {      
      // Normal Product View
      appendProductToGridContainer(basic_grid, essential_grid, add_on_grid, product_html, sectionName, newProduct);

      // Routine Product View
      appendProductToRoutineGridContainer(am_container, pm_container, sectionName, newProduct, productIndex, selected_variants_map);
    }
    
    updateSectionCartMap(newProduct, sectionName, variantId, newVariant.id);
    
    enableButtonListener();
    // Break the loop once a valid product is found and switched
    return;
  }
  
  if (attempts >= maxAttempts) {
    console.log("No valid alternative found after multiple attempts.");
    return;
  }
}

// Get Parent sections to be updated
function getSectionsToUpdate(sectionName) {
  const basic_list = ["section_cleanser", "section_toner", "section_moisturiser"];
  const essential_list = ["section_cleanser", "section_toner", "section_serum", "section_moisturiser", "section_sun_care"];
  const add_on_list = getAddOnProductCategoryList();

  let sections = [];

  if (basic_list.includes(sectionName)) sections.push("section_basics");
  if (essential_list.includes(sectionName)) sections.push("section_essentials");
  if (add_on_list.includes(sectionName)) sections.push("section_add_on");

  return sections;
}

function updateSectionData(product, section, preVariant, newVariant) {
  if (!sections_add_to_cart_map[section]) return;

  let updatedList = new Set(sections_add_to_cart_map[section].list);
  updatedList.delete(preVariant);
  
  if(!isProductSubcribeActive(product)){
    updatedList.add(newVariant);
  }
  sections_add_to_cart_map[section].list = Array.from(updatedList);
  sections_add_to_cart_map[section].count = sections_add_to_cart_map[section].list.length;
  sections_add_to_cart_map[section].total = getTotalPriceForAllProducts(sections_add_to_cart_map[section].list) || 0;
  sections_add_to_cart_map[section].link = generateLinkForCart(sections_add_to_cart_map[section].list) || "#";
}

function updateCartButton(section) {
  const cartButton = document.getElementById(`${section}_add_all_cart_link`);
  if (cartButton) {
    cartButton.innerHTML = getButtonHTMLforAddAllToCart(sections_add_to_cart_map[section].total, section);
  }
}

function updateSectionCartMap(product, sectionName, preVariant, newVariant) {
  const sectionsToUpdate = getSectionsToUpdate(sectionName);
  
  sectionsToUpdate.forEach(section => {
    updateSectionData(product, section, preVariant, newVariant);
    updateCartButton(section);
  });
}

function roundToTwo(num) {
  return Number(num.toFixed(2));
}

function generateLinkForCart(productIdList) {
  let linkText = `${tangent_client_domain_url}/cart/add?id[]=${productIdList[0]}`;
  
  for (let pid of productIdList.slice(1)) {
    linkText += `&id[]=${pid}`;
  }
  return linkText;
}

function getTotalPriceForAllProducts(productIdList) {
  let totPrice = 0;
  const productIdSet = new Set(productIdList);

  tangent_recommended_products.forEach(product => {
    if (product.variants && product.variants.edges.length > 0) {
      let variant = product.variants.edges[0].node;
      if (productIdSet.has(variant.id)) {
        totPrice += parseFloat(variant.price) || 0;
      }
    }
  });

  return totPrice;
}

function getVariantOfProductFromSelected(product, selected_variants){
  const products_variant_list = selected_variants[product.id] || [];
  const hasSelectedVariants = products_variant_list.length > 0;

  if(hasSelectedVariants){
    variant = getVariant(product, products_variant_list[0]);
  }
  else{
    variant = product.variants.edges[0].node;
  }
  return variant;
}

function isProductAvailable(product, variant) {
  // Check if the product is active
  if (product.status !== "ACTIVE") {
    return false;
  }
  return variant.available_for_sale;
}

function setTabOpen(tags) {
  const tabWrapper = document.querySelector("#tab-wrapper");
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabLinks = document.querySelectorAll(".tablinks");

  // Show tab wrapper
  tabWrapper.style.display = "block";

  // Determine the default tab index based on tags
  let tabIndex = 0;

  // Setting Essentials by Default
  if (tags.includes("routine_10_mins") || tags.includes("routine_15_mins")) {
    // tabIndex = 1;

    // Custom Text and Button Setting for Add On Section
    updateAddOnSectionButtonAndText("section_essentials")
  }
  
  // Hide all tab content and remove 'active' class from all links
  tabContents.forEach(tab => tab.style.display = "none");
  tabLinks.forEach(link => link.classList.remove("active"));

  // Show the appropriate tab content and activate the corresponding tab link
  tabContents[tabIndex].style.display = "flex";
  tabLinks[tabIndex].classList.add("active");
}

function setAddOnAddAllToCartButton(section, tabActiveSection){
  if(document.getElementById(section+"_add_all_to_cart")){
    document.getElementById(section+"_add_all_cart_link").innerHTML = getButtonHTMLforAddAllToCart(sections_add_to_cart_map[section].total, tabActiveSection);
  }
}

function setAddOnDiscountText(discountPercent){
  const addOnDiscountText = document.getElementById("section_add_on_discount_text");
  addOnDiscountText.innerHTML = `<b>SAVE ${discountPercent}%</b> ON YOUR EXTRAS WHEN YOU ADD YOUR REGIMEN TO YOUR CART`;
}

function createTabButtons(){
  for (var section in tabs_title_mapping) {
   createTabButton(section)    
  }
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(section_name, variant){
  const sectionsToUpdate = getSectionsToUpdate(section_name);
  
  sectionsToUpdate.forEach(section => {
    addToCarMapFunction(section, variant);
  });
}

const getDiscountedPrice = (amount, section) => {
  let discountPercentage = 0.10;
  if(section=="section_essentials"){
    discountPercentage = 0.15;
  }
  return roundToTwo(amount - (amount * discountPercentage));
}

const getButtonHTMLforAddAllToCart = (price, section) => {
  let discountPrice = getDiscountedPrice(price, section)
  return `<s style="color:rgba(128, 128, 128, 1)"><span>${currency_code} ${roundToTwo(price)}</span></s> <span>${currency_code} ${discountPrice}</span> - ${default_add_all_to_cart_text} `
}

function addToCarMapFunction(section, variant){
  let variantId = variant.id;
  let variantPrice = Number(variant.contextualPricing.price.amount);
  if (sections_add_to_cart_map[section]) {
    const sectionData = sections_add_to_cart_map[section];
    if (!sectionData.list.includes(variantId)) {
      sectionData.count++;
      sectionData.cart_link += `&id[]=${variantId}`;
      sectionData.list.push(variantId);
      sectionData.total+= variantPrice;
    }
  } else {
    sections_add_to_cart_map[section] = {
      count: 1,
      cart_link: `${tangent_client_domain_url}/cart/add?id[]=${variantId}`,
      list: [variantId],
      total: variantPrice
    };
  }  
  if(document.getElementById(section+"_add_all_cart_link")){
    document.getElementById(section+"_add_all_cart_link").innerHTML = getButtonHTMLforAddAllToCart(sections_add_to_cart_map[section].total, section);
  }
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
// Custom function - Adding meta properties to add to cart function call
function addToCart(btn){ 
  const variantArray = Object.values(tangent_selected_product_map);
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1,
    'properties': {
      '_type': 'tangent-quiz',
      '_variantIds': variantArray
    }
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    sendAddToCartEvent(formData.items);
    if(btn!=undefined){
      btn.innerHTML = default_addedToCartText;
      btn.classList.add("added-to-cart-style"); 
    }    
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {

    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");
    add_all_to_cart_p_tag.setAttribute('data-sectionName', section_name);
  
    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;
  
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
  
    return add_all_to_cart_p_tag;
  }

// Custom function - Adding meta properties to add to cart function call
function addAllToCartFunction(button){
  let sectionName = button.getAttribute("data-sectionName");
  let productData = getProductData(sectionName);
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(productData)
  })
  .then(response => {

    // Sending Event 
    sendAddToCartEvent(productData.items);
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function sendAddToCartEvent(items){
  let event_data_array = [];
  items.forEach(function (item) {
    const variantId = item.id;
    const productId = variant_product_map[variantId];
    const product = getProductFromId(productId);
    const variant = getVariantById(product, variantId);
    const event_data = {
      product_id: Number(productId),
      variant_id: Number(variantId),
      price: currency_code +" "+variant.node.contextualPricing.price.amount,
      product_name: product.title,
      variant_name: variant.node.title
    }
    event_data_array.push(event_data);
  });
  fetch("https://s.tangent.ai/recommendation-track", {
      method: "POST",
      headers: {
          "Content-Type": "application/json"
      },
      body: JSON.stringify({
          resp_id: resp_id,
          event_name: "added_to_cart",
          event_type: "click",
          recommendation_url: `https://www.thedetoxmarket.com/pages/detox-skin-quiz-recommendation?resp_id=${resp_id}`,
          attributes: {
              products: event_data_array
          }
      })
  })
}

function getProductData(sectionName){
  const sectionVariantList= sections_add_to_cart_map[sectionName].list;
  const allVariantList = Object.values(tangent_selected_product_map);
  let productData = {
   'items': []
  };
  for (let variantId of sectionVariantList) {
    let item = {
      'id': variantId,
      'quantity': 1,
      'properties': {
        '_type': 'tangent-quiz',
        '_variantIds': allVariantList
      }
    }
    productData.items.push(item);
  }
  return productData;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

const createDiscountTextParagraph = (section_name, text) => {
  let discount_text = document.createElement("p");
  discount_text.id = section_name+"_discount_text";
  discount_text.classList.add("tangent_section_discount_text");
  discount_text.innerHTML = text;
  return discount_text;
}

const createContainerForCartButton = (section_name) => {
  let cart_container = document.createElement("div");
  cart_container.id = section_name+"_cart_button_container";
  let text = 'GET YOUR ENTIRE REGIMEN & SAVE ';
  if(section_name.includes("section_essentials")){
    text+= '15%';
  }
  else if(section_name.includes("section_basics")){
    text+= '10%';
  }
  else{
    text = `<b>SAVE 10%</b> ON YOUR EXTRAS WHEN YOU ADD YOUR REGIMEN TO YOUR CART`
  }
  cart_container.appendChild(createDiscountTextParagraph(section_name, text));
  return cart_container;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    const basic_list = ["section_cleanser", "section_toner","section_moisturiser"];
    const essential_list = ["section_cleanser", "section_toner", "section_serum", "section_moisturiser", "section_sun_care"];
    const add_on_list = getAddOnProductCategoryList();
  
    for (const section_name in product_sections) {
      if(section_name!="section_basics" && section_name!="section_essentials" && section_name!="section_add_on"){
        // The created container will have both a container to show text and products
        var section_container = createSectionContainer(section_name);    
        
        // Creating text sections before products sections if exists
        if(text_sections!=undefined){
            createTextSectionBeforeProducts(text_sections,section_container,section_name);
        }    

        // Creating section to add all products
        section_container.appendChild(addSectionProductGridContainer(section_name));
        if (basic_list.includes(section_name)) {
            cloneAndAppend(section_container, "basic", section_basics_container);
        }
        
        if (essential_list.includes(section_name)) {
            cloneAndAppend(section_container, "essential", section_essentials_container);
        }
        
        if (add_on_list.includes(section_name)) {
          cloneAndAppend(section_container, "add_on", section_add_on_container);
        }
      }
      else{
        let addToCartContainer = createContainerForCartButton(section_name);
        let addAllToCart = createSectionAddAllToCart(section_name);
        addToCartContainer.appendChild(addAllToCart)
        if(section_name=="section_basics"){
          document.getElementById("section_basics_container").appendChild(addToCartContainer);
        }
        else if(section_name=="section_essentials"){
          document.getElementById("section_essentials_container").appendChild(addToCartContainer); 
        }
        else if(section_name=="section_add_on"){
          // ADDED TO SHOW DESCRIPTION SEPERATE IN MOBILE SCREEN
          let customContainer = createSectionContainer("section_product_description");
          customContainer.classList.add("tangent-hide-element");
          document.getElementById("section_add_on_container").appendChild(customContainer);
          document.getElementById("section_add_on_container").appendChild(addToCartContainer); 
        }
        else{
          // document.getElementById("section_works_container").appendChild(addAllToCart);
        }
      }
    }
}

function cloneAndAppend(container, prefix, targetContainer) {
    let clonedContainer = container.cloneNode(true);
    let targetChild = clonedContainer.children[1] || clonedContainer.children[0];

    if (targetChild) {
        targetChild.id = `${prefix}_${targetChild.id}`;
        targetChild.setAttribute("parentSection", prefix);
        targetContainer.appendChild(clonedContainer);
    }
}

const isDarkCircleDetected = () => {
  return tangent_quiz_tags.includes("tangent_selfie_dark_circles");
}

const getAddOnProductCategoryList = () => {
  return isDarkCircleDetected() 
    ? ["section_eye_care"] 
    : ["section_exfoliator", "section_eye_care"];
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

function createTextSection(product_sections, text_sections) {
  for (const section_name in text_sections) {
    if (product_sections[section_name] === undefined) {
      const section_container = createSectionContainer(section_name);
      const section_div = buildTextDiv(section_name, text_sections[section_name]);
      section_container.appendChild(section_div);
      renderSection(section_name, section_container);
    }
  }
}

function buildTextDiv(section_name, contentArray) {
  const section_div = document.createElement("div");
  section_div.id = `${section_name}_text_container`;
  section_div.classList.add("section_text_container", `${section_name}_text_container`);
  section_div.innerHTML = contentArray.join(' ');
  return section_div;
}

function renderSection(section_name, section_container) {
  let targetSelector = null;

  switch (section_name) {
    case "section_selfie":
      if (!enableChatGptContent) {
        targetSelector = "#section_selfie_container_parent";
      }
      break;
    case "section_ingredients":
      targetSelector = "#tangent-section_ingredients";
      break;
    case "section_add_on":
      targetSelector = "#section_add_on_container";
      break;
    case "section_am_pm":
      // targetSelector = "#tangent-am-pm-section"; // Uncomment if needed
      break;
    default:
      // targetSelector = "#tangent_sections_wrapper_element"; // Optional default
      break;
  }

  if (targetSelector) {
    const container = document.querySelector(targetSelector);
    if (container) {
      section_container.classList.remove("tabcontent");
      container.innerHTML = '';
      container.appendChild(section_container);
    }
  }
}


const setElementDisplayById = (elementId, displayStyle) => {
  const element = document.getElementById(elementId);
  if (element) {
      element.style.display = displayStyle;
  }
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

  const ctx = canvas.getContext( '2d' );
  const bb = canvas.getBoundingClientRect();
  var point = {
    _x:Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
    _y:Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
  }

  var skin_conditions = ["acne","darkspots","wrinkles","dark_circles","rosacea"];
  var click_found = false;
  for(var sc=0;sc <skin_conditions.length;sc++){
    if(isPointInsidePoligon(point,tangent_facemap_data[skin_conditions[sc]])){
      openConditionMessage(canvas,skin_conditions[sc]);
      click_found=true;
      break;
    }
  }
  if(!click_found){
    tangent_condition_message_popoup.style.display="none";
    console.log("no condition click");
  }
}

function openConditionMessage(canvas,condition){
  tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
  let rect = canvas.getBoundingClientRect();
  var point = {
    _x:event.clientX - rect.left,
    _y:event.clientY - rect.top
  }
  
  // Positioning Popup
  Object.assign(
    tangent_condition_message_popoup.style,
    {
      display:"block",
      left:(point._x) +"px",
      top:(point._y) +"px"
    }
  );
}

// Check whether click is inside condition points
function  isPointInsidePoligon(pt, points_list) {
  // https://stackoverflow.com/a/29915728/960654
  // ray-casting algorithm based on
  // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
    
  var x = pt._x,
    y = pt._y

  var inside = false;
  for(var c=0;c<points_list.length;c++){
    var points = points_list[c];
    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
      var xi = points[i][0],
        yi = points[i][1]
      var xj = points[j][0],
        yj = points[j][1]

      var intersect =
        yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
  }
  return inside
}

// Toggle hide highlight and show highlight
function toggleHighlight(status){
  if(status){
    setElementDisplayById('image-parent-container','block');
    setElementDisplayById('hideHighlight','block');
    setElementDisplayById('showHighlight','none');
    setElementDisplayById('selfie_canvas','block');
  }
  else{
    setElementDisplayById('hideHighlight','none');
    setElementDisplayById('showHighlight','block');
    setElementDisplayById('selfie_canvas','none');
  }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  const canvasImg = document.querySelector('#canvas_img');
  setElementDisplayById('canvas_img','block');
  if(response.selfie_url!=undefined && response.selfie_url!=null){
    setSelfieId(response["selfie_id"]);
    getSelfieMapping(response["selfie_id"]);
    if (canvasImg) {
        canvasImg.src = response.selfie_url;
    }
  }
  else{
    setElementDisplayById('chatgpt-text-loading-section','flex');
    if(tangent_default_selfie_image_url!=""){
      setElementDisplayById('image-loading-section','none');
      if (canvasImg) {
        canvasImg.src = tangent_default_selfie_image_url;
      }
    }
    else{
      setElementDisplayById('image-loading-section','none');
      setElementDisplayById("tangent_selfie_container","none");
    }
  }    
}

const resetMoreInfoButtonsInAddOn = (button) => {
  document.querySelectorAll(".more_info_button").forEach(element => {
    if (element.id.includes("add_on_section") && button.id !== element.id) {
      element.setAttribute('data-functionType', "open");
      element.textContent = "+ More Info";
    }
  });
};

const toggleMoreInfo = (button) => {
  const functionType = button.getAttribute("data-functiontype");
  const sectionName = button.getAttribute("data-sectionName");
  const productId = button.getAttribute("data-productId");
  const className = button.id;
  const descriptionContentElement = document.getElementById("section_product_description_container");
  if (functionType == "open") {
    openMoreInfo(button, className, sectionName, productId, descriptionContentElement);
  } else {
    closeMoreInfo(button, className, sectionName, descriptionContentElement);
  }
  if(isMobile() && button.id.includes("add_on_section")){
    resetMoreInfoButtonsInAddOn(button);
  }
};

const openMoreInfo = (button, className, sectionName, productId, descriptionContentElement) => {
  button.innerText = "X Close More Info";
  button.setAttribute("data-functiontype", "close");

  toggleElementsVisibility(className, false);

  if (shouldShowDescription(sectionName)) {
    showProductDescription(productId, descriptionContentElement);
  }
};

const closeMoreInfo = (button, className, sectionName, descriptionContentElement) => {
  button.innerText = "+ More Info";
  button.setAttribute("data-functiontype", "open");

  toggleElementsVisibility(className, true);

  if (shouldShowDescription(sectionName)) {
    hideProductDescription(descriptionContentElement);
  }
};

const toggleElementsVisibility = (className, hide) => {
  document.querySelectorAll("." + className).forEach(element => {
    element.classList.toggle("tangent-hide-element", hide);
  });

  if(!className.includes("add_on_section")){
    document.querySelectorAll("." + className+"_button").forEach(element => {
      element.classList.toggle("tangent-hide-element", !hide);
    });
  }
  
};

const shouldShowDescription = (sectionName) => {
  return sectionName === "section_eye_care" || sectionName === "section_exfoliator";
};

const showProductDescription = (productId, descriptionContentElement) => {
  if (!descriptionContentElement) return;
  
  const product = getProductFromId(productId);
  descriptionContentElement.classList.remove("tangent-hide-element");
  descriptionContentElement.classList.add("section_product_description_container", "tangent-hide-laptop");
  descriptionContentElement.innerHTML = `<div class="section_product_description_subcontainer">${product.body_html}</div>`;
};

const hideProductDescription = (descriptionContentElement) => {
  if (!descriptionContentElement) return;

  descriptionContentElement.classList.add("tangent-hide-element");
  descriptionContentElement.classList.remove("section_product_description_container");
  descriptionContentElement.innerHTML = "";
};

// Enabling button listeners
function enableButtonListener() {
  // Listener for "Add to Cart" buttons
  const allBtns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
  
  allBtns.forEach(button => {
    button.addEventListener('click', function(event) {
      addToCart(this);
    }, false);
  });

  // Listener for "Add to Cart" buttons
  const allCartBtns = document.querySelectorAll('.section_add_all_to_cart');
  
  allCartBtns.forEach(button => {
    button.addEventListener('click', function(event) {
      addAllToCartFunction(this);
    }, false);
  });

  const allMoreInfoBtns = document.querySelectorAll('.more_info_button');

  // Remove existing listeners
  allMoreInfoBtns.forEach(button => {
    button.removeEventListener("click", handleToggleMoreInfo);
  });
  
  // Add event listeners
  allMoreInfoBtns.forEach(button => {
    button.addEventListener("click", handleToggleMoreInfo, false);
  });
}

// Function that receives the clicked button
function handleToggleMoreInfo(event) {
  toggleMoreInfo(event.currentTarget); // Passes the clicked button
}

const loadElementsOnResponseData = () => {
    const allElements = document.querySelectorAll('.load-on-data');
    allElements.forEach(element => {
        element.style.display = "block";
    });
};

// Setting scores below the selfie
const setScores = (scores) => {
    let scoresPresent = false;
    let concernCount = 0;

    const scoreContainers = {
        acne: "Acne_Score",
        rosacea: "Rosacea_Score",
        darkspots: "DarkSpots_Score",
        wrinkles: "Wrinkles_Score",
        dark_circles: "DarkCircles_Score",
        texture: "Texture_Score",
    };

    Object.keys(scores).forEach(key => {
        if (scoreContainers[key]) {
            const containerId = `${scoreContainers[key]}_container`;
            const scoreId = `${scoreContainers[key]}`;
            
            // Update container display and score
            document.querySelector(`#${containerId}`).style.display = "flex";
            document.querySelector(`#${scoreId}`).innerHTML = scores[key];
            
            scoresPresent = true;
            concernCount++;
        }
    });

    // Show the overall container if any scores are present
    if (scoresPresent) {
        document.querySelector("#facemap_all_scores_container").style.display = "flex";
    }
};

// Called on image on load function
const drawOnCanvas = () => {
    if(getSelfieId()!=null){
      
      var selfie_canvas = document.querySelector('#selfie_canvas');
      var selfie_canvas_ctx = selfie_canvas.getContext('2d');
      
      selfie_canvas.addEventListener('click', function(e) {
          getCursorPosition(selfie_canvas, e)
      });
      
      var canvas_img = document.querySelector('#canvas_img');
      setCanvasDimensions(selfie_canvas, canvas_img);
      
      var prop = getImageSize(canvas_img.naturalWidth);
      if(tangent_facemap_data){
        drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
        drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
        drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
        drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
        drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
        drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"],getAcneLineWidth(prop));
      }
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width  = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop =  imgWidth/400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if(prop<1){
    return 'blur(1px)';
  }
  else if(prop<1.5){
    return 'blur(2px)';
  }
  else if(prop<2){
    return 'blur(4px)';
  }
  else if(prop<3){
    return 'blur(7px)';
  }
  else if(prop<4){
    return 'blur(12px)';
  }
  else{
    
  }
}

const getRosaceaBlur = (prop) => {
  if(prop<1){
    return 'blur(4px)';
  }
  else if(prop<1.5){
    return 'blur(4px)';
  }
  else if(prop<2){
    return 'blur(5px)';
  }
  else if(prop<3){
    return 'blur(13px)';
  }
  else if(prop<4){
    return 'blur(18px)';
  }
  else{
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 7;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - Acne");    
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if(prop<1){
    return 1;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 6;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - DarkSpots");    
  }
}

const getTextureLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 3;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 16;
  }
  else{
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 15;
  }
  else if(prop<4){
    return 30;
  }
  else{
    console.log("out of bound props - Wrinkle");    
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill=false, stroke=false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}
window.addEventListener("scroll", function () {
    let element = document.getElementById("skin-selfie-header-title"); // Replace with your actual element ID

    if (window.innerWidth > 768) { // Only apply on screens wider than 768px
        if (window.scrollY >= 100) {
            element.style.marginTop = "13%";
        } else {
            element.style.marginTop = "2%";
        }
    } 
});
